module.exports = __webpack_public_path__ + "img/leadTrash.9dfcbe9e.svg";